var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useCharts } from '../Charts';
import { Borders } from '../Borders';
import { defaultMargins } from '../../utils';
import { DEFAULT_MARGINS } from '../../utils/defaultMargins';
// TODO: Update struture of margins to be an object of { top, right, bottom, left }
var DEFAULT_DIMENSIONS = {
    margins: DEFAULT_MARGINS,
    height: 0,
    width: 0,
    boundedWidth: 0,
    boundedHeight: 0
};
export var combineChartDimensions = function (width, height, marginProps) {
    var margins = defaultMargins(marginProps);
    return {
        margins: margins,
        width: width,
        height: height,
        boundedHeight: Math.max(height - margins.top - margins.bottom, 0),
        boundedWidth: Math.max(width - margins.left - margins.right, 0)
    };
};
var CanvasContext = React.createContext(__assign({}, DEFAULT_DIMENSIONS));
export var useCanvas = function () { return React.useContext(CanvasContext); };
export var Canvas = function (_a) {
    var children = _a.children, height = _a.height, margins = _a.margins, borders = _a.borders, props = __rest(_a, ["children", "height", "margins", "borders"]);
    var _b = useCharts(), containerRef = _b.containerRef, width = _b.width;
    var _c = React.useState(DEFAULT_DIMENSIONS), dims = _c[0], setDims = _c[1];
    var canvasRef = React.useRef(null);
    React.useEffect(function () {
        var dimensions = __assign(__assign({}, combineChartDimensions(width, height, margins)), { canvasRef: canvasRef,
            containerRef: containerRef });
        setDims(dimensions);
    }, [width, height, canvasRef.current]);
    return (React.createElement(CanvasContext.Provider, { value: __assign(__assign({}, dims), props) },
        React.createElement("svg", { className: "Canvas", height: height, width: dims.width, ref: canvasRef },
            React.createElement("rect", { className: "Canvas-Border", height: height, width: dims.width, fill: "none" }),
            React.createElement("g", { className: "Canvas-Bounded", transform: "translate(" + dims.margins.left + ", " + dims.margins.top + ")" }, canvasRef.current !== null && children),
            borders !== undefined && (React.createElement(Borders, { margins: dims.margins, borders: borders, width: width, height: height })))));
};
//# sourceMappingURL=Canvas.js.map